import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
  namespaced: true,
  state: {
    objs: []
  },
  getters: {
    ...functions.createDefaultGetters(['work', 'user', 'bankAccount']),
    getByWork: state => work => {
      return state.objs.filter(eb => eb.work === work);
    },
    getByUser: state => user => {
      return state.objs.filter(eb => eb.user === user);
    },
    getByEmployment: state => (work, user) => {
      return state.objs.filter(eb => eb.work === work && eb.user === user);
    },
    getByBankAccount: state => bankAccount => {
      return state.objs.filter(eb => eb.bankAccount === bankAccount);
    }
  },
  mutations: {
    ...functions.createDefaultMutations(['work', 'user', 'bankAccount']),
  },
  actions: {
    ...functions.createDefaultActionsWithStore(['work', 'user', 'bankAccount'])
  },
}